(() => {
  function initialize() {
    const button = document.querySelector('.ss-menu-toggle');
    const panel = document.getElementById('ss-mobile-panel');
    if (!button || !panel || button.dataset.ssReady) return;
    button.dataset.ssReady = 'true';
    const close = () => {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Open navigation');
    };
    button.addEventListener('click', () => {
      const opening = button.getAttribute('aria-expanded') !== 'true';
      panel.hidden = !opening;
      button.setAttribute('aria-expanded', String(opening));
      button.setAttribute('aria-label', opening ? 'Close navigation' : 'Open navigation');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        document.querySelectorAll('.ss-nav details[open]').forEach(d => d.open = false);
      }
    });
    document.querySelectorAll('.ss-nav details').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        document.querySelectorAll('.ss-nav details').forEach(other => {
          if (other !== detail) other.open = false;
        });
      });
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.ss-nav')) {
        document.querySelectorAll('.ss-nav details[open]').forEach(d => d.open = false);
      }
    });
    window.matchMedia('(min-width: 900px)').addEventListener('change', close);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
